function getCountForCatalog (fileId) {
  if (!this.fileOverviews) return
  if (!fileId) return
  const fileOverview = this.fileOverviews[fileId]
  if (!fileOverview) return
  return fileOverview.count
}

export default getCountForCatalog